export const requestPermission = () => {
  console.log('Requesting User Permission……');

  // Use Notification API to request permission
  return Notification.requestPermission().then((permission) => {
    if (permission === 'granted') {
      // Permission granted
      console.log('Notification User Permission Granted.');
      return true;
    } else {
      // Permission denied
      console.log('User Permission Denied.');
      return false;
    }
  });
};
